import { cn } from '../../../lib/utils';
import { Button } from '../../ui/button';
import { ChevronLeft, Menu } from 'lucide-react';

interface SidebarHeaderProps {
  collapsed: boolean;
  onCollapse: () => void;
  onMobileClose: () => void;
}

export function SidebarHeader({ collapsed, onCollapse, onMobileClose }: SidebarHeaderProps) {
  return (
    <div className="flex h-16 items-center justify-between px-3 border-b border-border/50 bg-background/80 backdrop-blur-sm">
      <div className={cn(
        "flex items-center gap-2",
        "transition-all duration-300 ease-out",
        collapsed ? "lg:opacity-0 lg:w-0" : "lg:opacity-100 lg:w-auto"
      )}>
        {/* Logo/Brand Icon */}
        <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
          <span className="text-lg font-bold text-primary">M</span>
        </div>
        
        {/* Brand Name */}
        <span className={cn(
          "text-lg font-semibold",
          "bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/80",
          "transition-all duration-300 ease-out"
        )}>
          MediPadi
        </span>
      </div>

      <div className="flex items-center gap-2">
        {/* Mobile Close Button */}
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden hover:bg-primary/10"
          onClick={onMobileClose}
        >
          <Menu className="h-5 w-5 text-muted-foreground" />
        </Button>

        {/* Desktop Collapse Button */}
        <Button
          variant="ghost"
          size="icon"
          className="hidden lg:flex hover:bg-primary/10"
          onClick={onCollapse}
        >
          <ChevronLeft className={cn(
            "h-5 w-5 text-muted-foreground",
            "transition-all duration-300 ease-out",
            collapsed && "rotate-180"
          )} />
        </Button>
      </div>
    </div>
  );
}
